import { UcoastEl } from '@/scripts/core/UcoastEl'

export class CollectionNav extends UcoastEl {
	static htmlSelector = 'collection-nav'
	constructor() {
		super()
	}
}
